const map = {
	"./10.Telemundo_logo_2018.webp": 7652,
	"./102.mi musica reggaeton.webp": 1359,
	"./105.babyfirst tv.webp": 7912,
	"./106.cosmovision.webp": 3574,
	"./107.CNC-Logo.webp": 460,
	"./107.Canal CNC.webp": 8095,
	"./11.Tele-VID-en-vivo-Online.webp": 6163,
	"./12.Señal_Colombia_logo.webp": 7318,
	"./13.City_tv_Bogotá_logo.svg.webp": 6669,
	"./14.Discovery kids.webp": 1956,
	"./15.Disney-Channel.webp": 5596,
	"./16.Disney_Junior_logo.webp": 8331,
	"./17.babytv-2017.webp": 5439,
	"./18.Tooncast_logo.webp": 6702,
	"./19.Cartoon_Network_2010_logo.webp": 7585,
	"./2.Telemedellín.webp": 6320,
	"./20.Cartoonito_Logo_2021.webp": 9686,
	"./21.ESPN_wordmark.webp": 7515,
	"./22.ESPN2_logo.webp": 1694,
	"./23.Espn3.webp": 9800,
	"./24.ESPN 5.webp": 9727,
	"./25.ESPN_4_logo.webp": 2680,
	"./26.ESPN-7.webp": 2894,
	"./27.ESPN_6_logo.svg.webp": 5552,
	"./28.Discovery_Turbo_logo.webp": 7875,
	"./29.Love nature logo 2.webp": 1915,
	"./3.TV_Agro_logo..webp": 6641,
	"./30.Discovery_Channel_-_Logo_2019.webp": 5782,
	"./31.Animal_Planet_logo.webp": 7367,
	"./32.National-Geographic-Logo.webp": 9477,
	"./33.TCM_Latam_logo.webp": 8744,
	"./34.TLC_Logo.webp": 5032,
	"./35Discovery_Home_&_Health_logo..webp": 9666,
	"./36.InvestigationDiscoveryLogo2020.webp": 3968,
	"./37.HGTV_US_Logo_2015.webp": 6593,
	"./38.Cine Hispano.webp": 2068,
	"./38.Star_Channel_2021- blanco.webp": 5723,
	"./38.Star_Channel_2021.webp": 4033,
	"./39.TNT_Series_Logo_2016.webp": 7384,
	"./4.Canal 1.webp": 2716,
	"./40.TNT_Logo_2016.webp": 5876,
	"./41.SpaceLogo.webp": 346,
	"./42.FX_International_logo.webp": 4499,
	"./43.CinecanalLA.webp": 6486,
	"./44..Discovery-Science-Channel_logo.webp": 7361,
	"./45.TNT_Novelas.webp": 4556,
	"./46.Canal_DHE_logo.webp": 3258,
	"./47.Universal_TV_logo.webp": 1687,
	"./48.PLIM PLIM Fondo transparente 2.webp": 2977,
	"./48.PLIM PLIM Fondo transparente 4.webp": 251,
	"./48.Studio_Universal_2016.webp": 3412,
	"./49.Canal-Infantil.webp": 7370,
	"./49.RCN_Novelas_logo_2019.webp": 4058,
	"./5.Teleantioquia_logo.webp": 524,
	"./50.Señal_Institucional_logo.webp": 182,
	"./51.Glitz.webp": 526,
	"./52.Ve_Plus_Logo_2019.webp": 7974,
	"./53.Pasiones_Tv_logo.webp": 6129,
	"./54.Canal Congreso.webp": 7712,
	"./55.RCN Internacional - NuestraTele2018.webp": 8244,
	"./56.Food_Network_logo.webp": 5970,
	"./57.LOGO-TELEPACIFICO.webp": 4138,
	"./58.Teleislas_2012.webp": 8679,
	"./59.telecafé.webp": 8923,
	"./6.logo capsos 2019.webp": 7140,
	"./60.Canal_Capital_logo.webp": 6020,
	"./60.NuestraTele2018.webp": 9775,
	"./61.Telecaribe.webp": 7335,
	"./62.Canal_tro_logo.webp": 7935,
	"./63.canal zoom.webp": 3851,
	"./64.La Kalle logo.webp": 6753,
	"./65.Htv_logo.webp": 6411,
	"./66.Rumba tv png.webp": 6390,
	"./67.Telenostalgia png.webp": 8784,
	"./68.NTN24_logo.webp": 2242,
	"./69.Cable_Noticias_logo.webp": 5577,
	"./69.Caracol_HD2_2017.webp": 8292,
	"./7.Caracol_Televisión_Corporativo.webp": 1586,
	"./70.CNN en español copia.webp": 8588,
	"./70.RCH HD2.webp": 236,
	"./71.TeleSUR-Logo.webp": 3590,
	"./72.Deutsche_Welle_.webp": 4193,
	"./73.Hogar tv png.webp": 180,
	"./74.EWTN.webp": 9123,
	"./75.Enlace_Televisión_logo.webp": 5969,
	"./76.Canal_TeleAmiga_logo.webp": 6974,
	"./77.Cristovisión_logo 2.webp": 802,
	"./78.Mariavision png.webp": 9842,
	"./79.Canal_Trece_logo.webp": 3949,
	"./79.TeleantioquiaGo.webp": 963,
	"./8.logo capsos 2019.webp": 4130,
	"./80.Adult swim.webp": 4100,
	"./81.USA_Network_logo_(2016).webp": 2002,
	"./82.DreamWorks_Channel_Logo.webp": 5221,
	"./83.E_.webp": 2851,
	"./84.History_(2021).webp": 491,
	"./85.EJTV 2.webp": 4862,
	"./85.EJTV.webp": 9052,
	"./85.Logo_Lifetime_2020.webp": 1833,
	"./86.IVC_Network_Logo.webp": 6619,
	"./87.Canal la luz.webp": 534,
	"./87.Sony_Channel_Logo.webp": 8594,
	"./88.Sony_Movies_Logo.webp": 7045,
	"./89.AXN_logo_(2015).webp": 1590,
	"./9.RCN_logo_(2).webp": 2940,
	"./90.A&E_Network_logo.webp": 7220,
	"./90.sophia-tv.webp": 6104,
	"./91.History2_logo_(2022).webp": 4562,
	"./91.Sun channel.webp": 5099,
	"./93.Agrotendencia 2.webp": 2070,
	"./95.Mi musica salsa.webp": 9866,
	"./96.mimusica popular.webp": 1284,
	"./97.mi musica romantica.webp": 8194
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6080;